export interface RoadDividerType {
  value: string;
  label: string;
  defaultWidthM: number;
  strokeColor: string;
  strokePx: number;
  lineDash?: number[];
  corridorDash?: number[];
  costPerM: number;
}

/** NHAI/IRC median types. Stored `value` is stable for saved corridors. */
export const ROAD_DIVIDER_OPTIONS: readonly RoadDividerType[] = [
  {
    value: 'none',
    label: 'Undivided (no median)',
    defaultWidthM: 0,
    strokeColor: '#ffffff',
    strokePx: 1,
    lineDash: [3, 3],
    costPerM: 0,
  },
  {
    value: 'painted',
    label: 'Painted centre line (IRC 35)',
    defaultWidthM: 0.15,
    strokeColor: '#ffff00',
    strokePx: 1,
    lineDash: [5, 5],
    corridorDash: [8, 8],
    costPerM: 50,
  },
  {
    value: 'kerbed',
    label: 'Raised kerbed median',
    defaultWidthM: 1.2,
    strokeColor: '#6b7280',
    strokePx: 4,
    costPerM: 350,
  },
  {
    value: 'concrete',
    label: 'New Jersey / rigid concrete (IRC 119)',
    defaultWidthM: 0.6,
    strokeColor: '#8b4513',
    strokePx: 3,
    costPerM: 500,
  },
  {
    value: 'metal',
    label: 'Metal beam crash barrier (W-beam)',
    defaultWidthM: 0.45,
    strokeColor: '#c0c0c0',
    strokePx: 2,
    lineDash: [10, 5],
    corridorDash: [3, 6],
    costPerM: 800,
  },
  {
    value: 'wire_rope',
    label: 'Wire rope safety barrier',
    defaultWidthM: 0.3,
    strokeColor: '#94a3b8',
    strokePx: 1.5,
    lineDash: [2, 8],
    corridorDash: [2, 8],
    costPerM: 650,
  },
  {
    value: 'vegetation',
    label: 'Vegetated / landscaped median',
    defaultWidthM: 2.5,
    strokeColor: '#228b22',
    strokePx: 4,
    corridorDash: [2, 10],
    costPerM: 200,
  },
];

const BY_VALUE = new Map(ROAD_DIVIDER_OPTIONS.map((o) => [o.value, o]));

export function getRoadDividerType(type: string | null | undefined): RoadDividerType {
  return BY_VALUE.get(String(type || '')) || ROAD_DIVIDER_OPTIONS[1];
}

export function defaultDividerWidth(type: string | null | undefined): number {
  if (String(type || '') === 'none') return 0;
  return getRoadDividerType(type).defaultWidthM;
}

export function dividerCorridorDash(type: string | null | undefined): number[] | undefined {
  const t = String(type || '');
  if (t === 'none') return undefined;
  return getRoadDividerType(t).corridorDash;
}

export function separatorCostPerMeter(type: string | null | undefined): number {
  return getRoadDividerType(type).costPerM;
}
